import script from "./PayoutHistoryList.vue?vue&type=script&lang=ts&setup=true"
export * from "./PayoutHistoryList.vue?vue&type=script&lang=ts&setup=true"

import "./PayoutHistoryList.vue?vue&type=style&index=0&id=c5c796e2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c5c796e2"]])

export default __exports__